import { gql } from '@apollo/client';

export const GET_SEASONS = gql`
  query GetSeasons {
    getSeasons {
      id
      code
      displayName
      active
    }
  }
`;
